import { createContext, useContext } from "react";

export interface CopySelectionRange {
  minRow: number;
  maxRow: number;
  selectedColumnIds: Set<string>;
}

export interface CopySelectionStore {
  getRange: () => CopySelectionRange | null;
  setRange: (range: CopySelectionRange | null) => void;
  clear: () => void;
  isCellSelected: (rowIndex: number, columnId: string) => boolean;
  hasSelection: () => boolean;
  subscribe: (listener: () => void) => () => void;
}

interface CopySelectionContextValue {
  store: CopySelectionStore;
}

const CopySelectionContext = createContext<CopySelectionContextValue | null>(
  null,
);

export const useCopySelectionContext = () => {
  const context = useContext(CopySelectionContext);
  if (!context) {
    throw new Error(
      "useCopySelectionContext must be used within a CopySelectionProvider",
    );
  }
  return context;
};

export const CopySelectionProvider = CopySelectionContext.Provider;
